import { format, formatDistanceToNow } from 'date-fns';
import { enUS, ru, lv } from 'date-fns/locale';
import isDateLessThanWeekAgo from '@/utils/formatting/less-than-week-ago';
import { i18n } from '@/i18n';

const locales = { ru, lv };

/**
 * @param incomingDate { start: Date, end: Date }
 * @param needTime show time or not
 * @param needWeekAgo show days ago in week or not
 */
const prettyDates = (incomingDate, needTime = false, needWeekAgo = false) => {
  const locale = locales[i18n.locale] === undefined ? enUS : locales[i18n.locale];

  let date = incomingDate;
  if (typeof date === 'string') {
    date = { start: new Date(incomingDate), end: new Date(incomingDate) };
  } else {
    date = { start: new Date(date.start), end: new Date(date.end) };
  }

  let lessThanWeekAgo = isDateLessThanWeekAgo(date.start);

  const isDatesEqual = date.start.getTime() === date.end.getTime();

  let resultFormat = 'PP';
  if (needTime) {
    resultFormat += ' p';
  }

  if (lessThanWeekAgo && needWeekAgo) {
    return formatDistanceToNow(date.start, { addSuffix: true, locale });
  } else {
    const start = format(date.start, resultFormat, { locale });
    if (isDatesEqual) {
      return start;
    } else {
      const end = format(date.end, resultFormat, { locale });
      return `${start} - ${end}`;
    }
  }
};

export default prettyDates;
